import { format } from 'date-fns';
import { Message } from '../../models/types';
import { useAuth } from '../../context/AuthContext';

interface ChatMessageProps {
  message: Message;
}

const ChatMessage = ({ message }: ChatMessageProps) => {
  const { currentUser } = useAuth();
  const isOwnMessage = message.senderId === currentUser?.uid;

  return (
    <div className={`mb-4 flex ${isOwnMessage ? 'justify-end' : 'justify-start'}`}>
      <div
        className={`max-w-[70%] rounded-lg px-4 py-2 ${
          isOwnMessage
            ? 'bg-primary-600 text-white'
            : 'bg-gray-100 text-gray-900'
        }`}
      >
        <p className="break-words whitespace-pre-wrap">{message.content}</p>
        <p className="text-xs mt-1 opacity-75">
          {format(message.createdAt, 'HH:mm')}
        </p>
      </div>
    </div>
  );
};

export default ChatMessage;